<template>
  <div class="row">
      <div class="col-md-6">
<span class="float-right">

    Vista:
</span>
      </div>
    <div v-for="icon in icons" :key="icon.id">
      <div class="col-md-3">
        <button
          type="button"
          class="btn btn-sm btn-outline-success btn-gr ml-1 float-right"
          @click.prevent="showDetailChild(index, 'component-info')"
        >
          <i :class="icon.icon" aria-hidden="true"></i>
        </button> <br/>
      <span style="font-size:9px">{{icon.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "General-list-component",
  data() {
    return {
      icons: [
        { id: 1, name: "cuadricula", icon: "fa fa-th-large" },
        { id: 2, name: "lista", icon: "fa fa-th-list" }
      ]
    };
  }
};
</script>

<style>
</style>